import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { MenuItem } from "@material-ui/core";

import PrefDialog from "components/Global/Metric/PrefDialog";
import OptionsMenu from "components/Global/OptionsMenu/OptionsMenu";
import FundAttachments from "./FundAttachments";
import FundNotes from "./FundNotes";
import AlertContainer from "components/TopNavigation/Alerts/AlertContainer";
import ReminderContainer from "components/TopNavigation/Reminders/ReminderContainer";
import { MyContext} from "components/Portfolio/index";

class FundTableOptionsMenu extends React.Component {
  state = {
    isPrefDialogOpen: false,
    isAlertModalOpen: false,
    isReminderModalOpen: false,
  };

  options = [
    { id: 1,
      value: "Edit Group",
      render: (fundId) => {
        return (
          <MyContext.Consumer key={1}>
            {( { fundModalEdit }  ) => {
              return (<MenuItem
              key={1}
              onClick={() => {
                fundModalEdit(fundId)                
              }}
            >
              {'Edit group'}
            </MenuItem>
              )
            }}
          </MyContext.Consumer>
        )
      }
    },    
    { id: 2, isHR: true },
    { id: 3, value: "Notes", onClick: optionId => { this.openNotes(); } },
    { id: 4, value: "Attachments", onClick: optionId => { this.openAttachments(); } }
  ];

  openNotes = () => {
    this.setState({ isNotesOpen: true });
  };

  closeNotes = () => {
    this.setState({ isNotesOpen: false });
  };

  openAttachments = () => {
    this.setState({ isAttachmentsOpen: true });
  };

  closeAttachments = () => {
    this.setState({ isAttachmentsOpen: false });
  };

  handlePrefDialogOpen = optionId => {
    this.setState({
      isPrefDialogOpen: optionId == 2
    });
  };

  handlePrefDialogClose = () => {
    this.setState({ isPrefDialogOpen: false });
    this.props.onClose();
  };

  renderPrefDialog() {
    return (
      <PrefDialog
        isMetric={false}
        screenType={this.props.screenType}
        onClose={this.handlePrefDialogClose}
        isOpen={this.state.isPrefDialogOpen}
        prefData={this.props.metrics}
        maxHeight={900}
        maxCount={6}
      />
    );
  }

  openAlertModal = () => {
    this.setState({
      isAlertModalOpen: true
    })
  };

  closeAlertModal = () => {
    this.setState({
      isAlertModalOpen: false
    })
  };

  openReminderModal = () => {
    this.setState({
      isReminderModalOpen: true
    })
  };

  closeReminderModal = () => {
    this.setState({
      isReminderModalOpen: false
    })
  };


  render() {
    const { order, orderBy, columns } = this.props;
    const { id } = this.props;
    const { isAttachmentsOpen, isNotesOpen, options, isAlertModalOpen, isReminderModalOpen } = this.state;

    return (
      <React.Fragment>
        <AlertContainer
          isModalOpen={isAlertModalOpen}
          closeModal={this.closeAlertModal}
          showAlertIcon={false}
          showReminderIcon={false}
        />
        <ReminderContainer
          isModalOpen={isReminderModalOpen}
          closeModal={this.closeReminderModal}
        />
        {this.renderPrefDialog()}
        <OptionsMenu
          options={this.options}
          maxHeight={900}
          fundId={id}
          testId={id}
          />
        <FundAttachments
          fundId={id}
          isOpen={isAttachmentsOpen}
          openAttachments={this.openAttachments}
          closeAttachments={this.closeAttachments}
        />
        <FundNotes
          fundId={id}
          isOpen={isNotesOpen}
          openNotes={this.openNotes}
          closeNotes={this.closeNotes}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = () => {
  return {

  }
}
export default compose(
  connect(
    mapStateToProps,    
  ),
  withRouter
)(FundTableOptionsMenu);
